import React, { useEffect } from 'react'
import { postTabletVisited } from 'src/services/api/metrics'

import "./style.css"

const MorePage = () => {
  useEffect(() => {
    postTabletVisited("DISCOVER_MORE")
  }, [])

  /* content embeded for now https://xd.adobe.com/view/aa7ea23b-3b12-4b17-8f72-eae7afa9776e-ff2d/screen/bc78ad4d-7f61-4852-88f5-c835f9fd835e/specs/ */
  return (
    <div className="flex-column home" style={{
      display: 'flex',
      flexDirection: 'column'
    }}>
      <iframe
        className="discover-more-container"
        src="https://exfluency.com/discover-more/"
        title="Discover More"
      />
    </div>
  )
}

export default MorePage